import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { Box, CardActionArea } from '@mui/material';
import { ProductApplicationSegmentCardCollectionEntry } from '../../../graphql/pimcore/modules/siteContent/types/SiteContentElement';

interface SolutionsCardProps {
    applicationSegment: ProductApplicationSegmentCardCollectionEntry;
}

export default function SolutionsCard({ applicationSegment }: SolutionsCardProps) {
    const { imageUrl, name, route } = applicationSegment;
    return (
        <Link to={route}>
            <Box
                className="card_group"
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '10px',

                    /* 讓圖片平滑放大（整個 group hover 即生效） */
                    '& .MuiCardMedia-root': {
                        width: '100%',
                        height: '100%',
                        transition: 'transform 0.3s ease-in-out',
                        transformOrigin: 'center center',
                    },
                    '&:hover .MuiCardMedia-root': {
                        transform: 'scale(1.2)',
                    },
                }}
            >
                <CardActionArea sx={{ overflow: 'hidden' }}>
                    <Card
                        className="card"
                        style={{ borderRadius: '10px' }}
                        variant="outlined"
                        sx={{ ':hover': { opacity: 0.8 } }}
                    >
                        <CardMedia
                            className="card"
                            image={imageUrl}
                            sx={{
                                borderRadius: '10px',
                                transition: 'transform 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'scale(1.2)',
                                },
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '99%',
                                    height: '100%',
                                    backgroundColor: 'rgba(73, 74, 77, 0.5)',
                                    borderRadius: '10px',
                                }}
                            />
                        </CardMedia>
                    </Card>
                </CardActionArea>
                <div className="rgba2" id="geek"></div>
                <div className="img-tip">
                    <span className="card-font">{name}</span>
                </div>
            </Box>
        </Link>
    );
}
